import { useMemo } from 'react';
import { Typography, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { format } from 'date-fns';
import { Consultant } from '@/types';
import { AvatarPlaceholder } from '@/components/shared/avatar-placeholder';

interface Props {
  consultant: Consultant;
}

export default function BookingConsultantDetailed({ consultant }: Props) {
  if (!consultant) return null;

  const { statusLabel, statusColor } = useMemo(() => {
    if (consultant.isDeleted) {
      return { statusLabel: 'Deleted', statusColor: '#F46262' };
    }
    if (consultant.isDeactivated) {
      return { statusLabel: 'Deactivated', statusColor: '#2A4BC2' };
    }
    if (consultant.status === false) {
      return { statusLabel: 'Hidden', statusColor: '#F6C38B' };
    }
    if (consultant.isVerified) {
      return { statusLabel: 'Active', statusColor: '#1C8271' };
    }
    return { statusLabel: '-', statusColor: '#999' };
  }, [consultant]);

  return (
    <div className="detailed-wrapper" style={{ flex: 1 }}>
      <div className="detailed-content">
        {consultant.profilePhoto ? (
          <div className="cronofy-modal-img-wrap">
            <img
              src={consultant.profilePhoto}
              alt="Profile Photo"
              className="cronofy-modal-img"
            />
          </div>
        ) : (
          <div
            style={{
              overflow: 'hidden',
              height: 140,
              width: 140,
              borderRadius: 16,
              fontSize: 36,
            }}
          >
            <AvatarPlaceholder
              firstName={consultant.firstName}
              lastName={consultant.lastName}
            />
          </div>
        )}

        <div className="details-section-column">
          <InfoLine
            label="Consultant"
            value={`${consultant.firstName} ${consultant.lastName}`}
          />
          <InfoLine label="Email" value={consultant.email} />
          <InfoLine label="Phone" value={consultant.phone || '-'} />
          <div className="details-section-line">
            <Typography.Text className="general-info-text">
              Status
            </Typography.Text>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  backgroundColor: statusColor,
                }}
              />
              <Typography.Text>{statusLabel}</Typography.Text>
            </div>
          </div>
          <InfoLine label="Rate ($/15m)" value={consultant.rate.toString()} />
        </div>
      </div>
    </div>
  );
}

function InfoLine({ label, value }: { label: string; value: string }) {
  return (
    <div className="details-section-line">
      <Typography.Text className="general-info-text">{label}</Typography.Text>
      <Typography.Text className="general-info-value">{value}</Typography.Text>
    </div>
  );
}
